import React from 'react'
import { observer } from 'mobx-react'
import styles from './DocumentCreationItem.sass'
import Button from 'components/Button'
import { IconButton } from 'components/IconButton'
import Icon from 'components/Icon'
import {
  Dropdown,
  DropdownItem,
  DropdownItemTitle,
  DropdownScroll,
} from 'components/Dropdown'
import { DocumentCreationItemViewModel } from './DocumentCreationItemViewModel'
import MiddleEllipsis from 'components/MiddleEllipsis'
import { Id } from 'types/definitions'

interface DocumentCreationItemProps
  extends React.HTMLAttributes<HTMLButtonElement> {
  index: number
  vm: DocumentCreationItemViewModel
  removeFile: (index: number) => void
}

function getDocumentTypeDropdownDataTest(typeId: Id, fileName: string) {
  switch (typeId) {
    case 'FINAL_RETURN':
      return `upload-final-documents-file-document-type-dropdown-final-return-item-${fileName}`
    case 'PREP_NOTES':
      return `upload-final-documents-file-document-type-dropdown-prep-notes-item-${fileName}`
    case 'REVIEW_NOTES':
      return `upload-final-documents-file-document-type-dropdown-review-notes-item-${fileName}`
    case 'EXTENSION_CONFIRMATION':
      return `upload-final-documents-file-document-type-dropdown-extension-confirmation-item-${fileName}`
    case 'DRAFT_RETURN':
      return `upload-draft-documents-file-document-type-dropdown-${fileName}`
  }

  return undefined
}

export const DocumentCreationItem = observer(
  ({ index, vm, removeFile }: DocumentCreationItemProps) => {
    return (
      <div className={styles.creationItem}>
        <div className={styles.creationActions}>
          <IconButton
            className={styles.removeButton}
            onClick={() => removeFile(index)}
          >
            <Icon name="close" />
          </IconButton>
        </div>
        <div className={styles.creationInfo} title={vm.file.name}>
          <MiddleEllipsis>
            <span className={styles.creationTitle}>{vm.file.name}</span>
          </MiddleEllipsis>
        </div>
        <div>
          <Dropdown
            autoDismiss
            position="bottom-end"
            button={
              <Button
                className={styles.documentTypeButton}
                borderless
                size="normal"
                iconRight={<Icon name="dropdown" />}
                dataTest={`upload-final-documents-file-document-type-dropdown-${vm.file.name}`}
              >
                {vm.typeName}
              </Button>
            }
          >
            <DropdownScroll>
              {vm.types &&
                vm.types.map((type, index) => (
                  <DropdownItem
                    key={index}
                    onClick={() => vm.setDocumentType(type)}
                    active={vm.selectedType === type}
                    checkmark={vm.selectedType === type}
                    dataTest={getDocumentTypeDropdownDataTest(
                      type.shortId,
                      vm.file.name,
                    )}
                  >
                    <div className={styles.documentType}>
                      <DropdownItemTitle className={styles.documentTypeTitle}>
                        {type.name}
                      </DropdownItemTitle>
                    </div>
                  </DropdownItem>
                ))}
              <DropdownItem
                onClick={() => vm.setDocumentType(null)}
                active={!vm.isPlaceholder && !vm.selectedType}
                checkmark={!vm.isPlaceholder && !vm.selectedType}
              >
                <div className={styles.documentType}>
                  <DropdownItemTitle className={styles.documentTypeTitle}>
                    Other documents
                  </DropdownItemTitle>
                </div>
              </DropdownItem>
            </DropdownScroll>
          </Dropdown>
        </div>
      </div>
    )
  },
)
